var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticStyle:{"font-size":"110%"}},[_vm._v(_vm._s(_vm.$t(_vm.label)))])}
var staticRenderFns = []

export { render, staticRenderFns }